export default __webpack_public_path__ + "static/blob3-36dc974cc467f551d730cc2be9e95802.svg";